<template>
  <div class="strip">
    <figure @click="visibleHandler" :class="{ brightArea: visibleButton }">
      <img
        src="@/assets/inv.jpg"
        data-src="img/location_1.jpg"
        class="img-fluid lazy"
        alt=""
      />
      <a class="strip_info">
        <small v-if="fromWebsite">Website</small>
        <small v-else-if="ticket.table"> {{ ticket.table.name }}</small>
        <small v-else-if="ticket.room"> {{ ticket.room.name }}</small>
        <small v-else>TakeAway</small>
        <div class="item_title">
          <h3>{{ ticket.order_number }}</h3>
        </div>
      </a>
    </figure>
    <div class="ButtonArea" v-if="visibleButton">
      <button
        @click="GetSingleKitchenTickets(ticket.id, 'modal-' + ticket.id)"
        class="btn btnSubmit"
      >
        Print
      </button>

      <Button class="btn btnCancel" @click="visibleButton = false"
        >Cancel</Button
      >
    </div>
    <!-- {{TicketsSingleData}} -->
    <CModal
      Text="customize"
      ref="customerModal"
      headerText="Kitchen Ticket"
      :width="450"
      submitText="Print"
      :hideButton="true"
      @onClickSubmit="PrintKitchenTicket"
      :visibleFooter="false"
      :modalName="'modal-' + ticket.id"
    >
      <template v-slot:content>
        <div v-for="(item, index) in kotTicketNumber" :key="item">
          <div style="padding:20px">
            <label
       class="label12"
            >
              {{ computedVal(item).key }}
            </label>

            <button
              style="border:none"
              class="printbutton"
              @click="
                PrintMethod(
                  index,
                  computedVal(item).data,
                  computedVal(item).key
                )
              "
            >
              Print
            </button>
          </div>

      
          <KitchenTicketSingleView
            v-show="false"
            :Order="TicketsSingleData"
            :OrderDetails="ticket"
            :TicketNumber="finalOutput"
            ref="Bills"
          />
        </div>
      </template>
    </CModal>
  </div>
</template>

<script>
import { CustomModal as CModal } from "@/components/base/index.js";

import { PlusMinusInput, MenuComponent } from "@/components/base/index.js";

import KitchenTicketSingleView from "../KitchenTicketSingle/index";
import("./style.css");
import axios from "@/plugins/axios";
export default {
  name: "ProductView",

  props: {
    ticket: {
      type: Array,
      default: []
    },
    count: {
      type: Number,
      default: 1
    },
    visibleButton: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    units: [],
    completeBill: false,

    TicketsSingleData: [],
    selectedProducts: [],
    selectedProducts: [],
    kotTicketNumber: null,
    finalOutput: null,
    finalOutput: null
  }),
  components: {
    PlusMinusInput,
    MenuComponent,
    KitchenTicketSingleView,
    CModal
  },
  computed: {
    fromWebsite() {
      return String((this.ticket && this.ticket.note) || '').indexOf('Website pickup') === 0;
    },
  },
  methods: {
    PrintMethod(index, item, number) {
      this.TicketsSingleData = item;
      // this.finalOutput = number;


            this.finalOutput = number.substring(
              number.lastIndexOf("-") + 1,
              number.length
            );
      this.PrintKitchenTicket(index);
    },
    computedVal(data) {
      const Keys = Object.keys(data);
      return {
        key: Keys[0],
        data: data[Keys[0]]
      };
    },
    visibleHandler() {
      if (!this.visibleButton) {
        this.visibleButton = !this.visibleButton;
      }
    },

    PrintKitchenTicket(index) {
      setTimeout(() => {
        this.$refs.Bills[index].print();
      }, 200);
    },
    openToSelectCustomer(modalName) {
      this.$refs.customerModal.show(modalName);
    },

    GetSingleKitchenTickets(orderId, modalName) {
      axios
        .get(`hms/web/orders/kot/${orderId}`)
        .then(res => {
          let values = [];
          Object.keys(res.data.items).map(function(key, index) {
            values.push({ [key]: res.data.items[key] });
          });
          this.kotTicketNumber = values;

          this.openToSelectCustomer(modalName);
        })

        .catch(err => {});
    },

    emit() {
      this.visibleButton = false;
    }
  },
  created() {}
};
</script>

<style>
.label12{
      font-weight: 500;
    background: darkgray;
    width: 129px;
    padding: 4px;
    height: 26px;
    margin-bottom: 3px;
}
.printbutton {
  width: 80px;
  height: 30px;
  border-radius: 50px;
  margin-left: 50px !important;
  background: green;
  color: white !important;
}
</style>
